<template>
  <div class="layout-background uk-height-1-1">
    <router-view />
  </div>
</template>

<style type="text/css" scoped>
.layout-background {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFF;
}
</style>
